import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

class Loading extends Component {
  constructor(props) {
    super(props);
    var text="Cargando Información..."
    if(typeof(props.text)!=="undefined"){
      text=this.props.text
    }
    //console.log('texto loading',text)
    this.state = {
      text:text,
    }
  }

  render(){
    const {text}=this.state
      return (
        <Grid
            item
            xs={12}
            sm={12}
            md={12}
            xl={12}
            >
            <Typography
                variant="caption"
            >
                <CircularProgress
                variant="indeterminate"

                size={12}
                thickness={3}
                style={{marginRight: 10}}
                />
                {text}
            </Typography>
        </Grid>
      );
  }
  
}


export default compose(withRouter)(Loading);
